import { BaseModel, HasId } from '@app/shared/models/base';
import { DisplayName } from '@app/shared/components/select/base-select-with-id.component';

export class VehicleCode extends BaseModel
                         implements DisplayName, HasId {

    get id(): string {
        return this.code;
    }

    public code: string;
    public name: string;

    constructor(json?: any) {
        super(json);
    }

    get displayName(): string  {
        return this.name;
    }
}
